import axiosInstanceNew from "lib/axiosinstanceNew";

const SuggestedTutor = class {
    constructor() {
        this.baseUrl = "enquiry/suggested_tutors/";
}


async listAllNewEnquiry() {
    return (
      await axiosInstanceNew.get(`${this.baseUrl}`)
    ).data;
  }


}
export default new SuggestedTutor();
